import React, { createContext, useContext, useState, useEffect } from "react";

const AppContext = createContext();

export const useAppContext = () => useContext(AppContext);

export const AppProvider = ({ children }) => {
  const [showFreeTrialForm, setShowFreeTrialForm] = useState(() => {
    const stored = localStorage.getItem("showFreeTrialForm");
    return stored !== null ? JSON.parse(stored) : false;
  });

  useEffect(() => {
    localStorage.setItem("showFreeTrialForm", JSON.stringify(showFreeTrialForm));
  }, [showFreeTrialForm]);

  return (
    <AppContext.Provider value={{ showFreeTrialForm, setShowFreeTrialForm }}>
      {children}
    </AppContext.Provider>
  );
};
